import { z } from 'zod';
import { agencyTaskPrioritySchema } from './list';

// Bulk-edit surface: every field the single-task PATCH /v1/agency_tasks/:id
// route accepts except `title`/`description` (unique per task, not a
// meaningful "set the same value on N tasks" operation), `postId`
// (structural, not exposed by any edit UI) and `blockedBy` (defined
// relative to sibling tasks within one post, so it can't generalize across
// an arbitrary multi-post selection).
export const bulkUpdateAgencyTaskSchema = z.object({
  ids: z.array(z.string().min(1)).min(1),
  dueDate: z.coerce.date().nullable().optional(),
  completedAt: z.coerce.date().nullable().optional(),
  priority: agencyTaskPrioritySchema.optional(),
  userId: z.string().nullable().optional(),
  clientId: z.string().nullable().optional(),
  assignedToClient: z.boolean().optional(),
  isPrivate: z.boolean().optional(),
});

export type BulkUpdateAgencyTaskSchema = z.infer<typeof bulkUpdateAgencyTaskSchema>;
